import Vue from 'vue'
import Router from 'vue-router'


import Login from './views/Login'
import WXLoginResult from './views/WXLoginResult'
import config from '@/config';
import Vow from './views/Vow';
import Team from './views/Team';
import NewVow from './views/NewVow'
import VowDraw from './views/VowDraw'
import ShareIndex from './views/ShareIndex'
import HelpMe from  './views/HelpMe';
import ActivityOver from  './views/ActivityOver';
import Wish from './views/Wish';
import Poster from './views/Poster';
import Home from './views/Home';
Vue.use(Router)

var router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    {
      meta: { title: "", auth: 0 },
      path: "/login",
      name: "login",
      component: Login
    },
    // {
    //   meta: { title: "祈福武汉", auth: 1 },
    //   path: "/",
    //   component: Vow
    // },
    // {
    //   meta: { title: "祈福武汉", auth: 0},
    //   path: "/wish",
    //   component: Wish
    // },
    // {
    //   meta: { title: "我的奖品", auth: 1 },
    //   path: "/team",
    //   component: Team
    // },
    {
      meta: { title: "祈福武汉", auth: 1 },
      path: "/vowdraw",
      component: VowDraw
    },
    {
      meta: { title: "祈福武汉", auth: 1 },
      path: "/newvow",
      component: NewVow
    },
    {
      meta: { title: "祈福武汉", auth: 1 },
      path: "/shareindex",
      component: ShareIndex
    },
    {
      meta: { title: "", auth: 0 },
      path: "/wxloginresult",
      component: WXLoginResult
    },
    // {
    //   meta: { title: "好友助力", auth: 1 },
    //   path: "/helpme",
    //   component: HelpMe
    // }, 
    // {
    //   meta: { title: "活动公布", auth: 1 },
    //   path: "/activity",
    //   component: ActivityOver
    // },
	{
	  meta: { title: "祈福武汉", auth: 1 },
	  path: "/poster",
	  component: Poster
	},
	
	{
	  meta: { title: "祈福武汉", auth: 1 },
	  path: "/",
	  component: Home
	},
  ]
});
var keyUrl = function () {
  var items = [];
  var url = location.href;
  if (url === undefined || typeof url != "string") {
    return null;
  }
  var json = {};
  var newurl = url.split("#")[0];
  var arr = newurl.split("?");
  if (arr.length > 1) {
    items = arr[1].split("&");
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i].split("=");
      json[item[0]] = item[1];
    }
  }
  return json;
}
//路由守卫
router.beforeEach((to, from, next) => {
  var next_url = {
    path: "",
    query: {}
  }
  if (to.meta) {
    // var cid = localStorage.getItem('cid');
    // var cInfo = localStorage.getItem('configInfo_'+ cid)
    // console.log('当前配置文件信息',cInfo)
    // cInfo && cInfo.webTitle ? cInfo.webTitle : 
    /* 路由发生变化修改页面title */
    if (to.meta.title) document.title = to.meta.title;
    else document.title = "祈福武汉";
    /* 验证授权 */
    do {
      if (!to.meta.auth || to.meta.auth == 0) break;
      // localStorage.removeItem(config.login_key);
      var app_login_user = localStorage.getItem(config.login_key);
      if (app_login_user) app_login_user = JSON.parse(app_login_user);
      // sessionkey = '24681570c3751d3939157361a69f6ed1b4dad553'
      // localStorage.setItem("sessionkey", sessionkey);
      console.log(to.meta.auth == 1 && app_login_user == null)
      console.log(to.meta.auth)
      console.log('888')
      console.log(app_login_user)
      // console.log(to)
      //前台授权
      if (to.meta.auth == 1 && app_login_user == null) {
        console.log("JSON.stringify(to)", JSON.stringify(to))
        localStorage.setItem("login_redirect", JSON.stringify(to));
        next_url.path = "/login";
        var urlData = keyUrl();
        var q = to.query;
        if (q.a || q.auth_token) {
          urlData = q;
        }
        // if(urlData.sessionkey) break;
        // if(urlData.) next_url.query = {auth_token:urlData.auth_token};
        next_url.query = urlData;
        break;
      }
    } while (false);
  }
  if (next_url.path != "" && next_url.path.indexOf("://") >= 0)
    window.location.href = next_url.path;
  else if (next_url.path != "")
    next(next_url)
  else {
    console.log('to:%%%%', to)
    next();
  }
});

export default router;
